import { pletApiRequest } from './client';
import { isRetiredViewId } from '../../components/SavedViews/types';

export const ViewsAPI = {
  list: async () => {
    const result = await pletApiRequest('/views');
    return (result.views || []).filter((view) => !isRetiredViewId(view?.id));
  },

  get: async (viewId) => {
    if (isRetiredViewId(viewId)) {
      return null;
    }
    const result = await pletApiRequest(`/views/${viewId}`);
    return result.view;
  },

  create: async (view) => {
    const result = await pletApiRequest('/views', {
      method: 'POST',
      body: JSON.stringify(view),
    });
    return result.view;
  },

  update: async (viewId, view) => {
    const result = await pletApiRequest(`/views/${viewId}`, {
      method: 'PUT',
      body: JSON.stringify(view),
    });
    return result.view;
  },

  delete: async (viewId) => {
    const result = await pletApiRequest(`/views/${viewId}`, {
      method: 'DELETE',
    });
    return result;
  },
};
